import Vue from 'vue';
import VueRouter from 'vue-router';
import ChannelList from './cms/channel/List';
import ChannelEdit from './cms/channel/Edit';
import ChannelView from './cms/channel/View';
import ChannelBroadcast from './cms/channel/Broadcast';
import RecordingFiles from './cms/RecordingFiles';
import StatisticsChannel from './cms/StatisticsChannel';
import StatisticsViewerEnvironment from './cms/StatisticsViewerEnvironment';
import StatisticsStorageUsage from './cms/StatisticsStorageUsage';
import StatisticsServiceUsage from './cms/StatisticsServiceUsage';
import StatisticsServiceLogs from './cms/StatisticsServiceLogs';
import ChattingStatisticsUsage from './cms/ChattingStatisticsUsage';
import PreferencesGeneral from './cms/PreferencesGeneral';
import PreferencesProfileGroups from './cms/PreferencesProfileGroups';
import PreferencesProfileGroup from './cms/PreferencesProfileGroup';
import PreferencesMembers from './cms/PreferencesMembers';
import PageNotFound from './cms/PageNotFound';
import CreatorChannelView from './cms/creator/ChannelView';
import PreferencesServiceAccount from './cms/PreferencesServiceAccount';
import PreferencesLoginAccount from './cms/PreferencesLoginAccount';
import PreferencesDuplicateBlockManage from './cms/PreferencesDuplicateBlockManage';
import PreferencesDuplicateBlockSessions from './cms/PreferencesDuplicateBlockSessions';
import PreferencesDuplicateBlockLogs from './cms/PreferencesDuplicateBlockLogs';
import PreferencesCaptureBlockLogs from './cms/PreferencesCaptureBlockLogs';
import PreferencesCaptureBlockUsers from './cms/PreferencesCaptureBlockUsers';
import ProgramMediaContents from './cms/program/MediaContents';
import ProgramSchedules from './cms/program/Schedules';
import ProgramWaitMediaContents from './cms/program/WaitMediaContents';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/channels',
            name: 'cms-channels-list',
            component: ChannelList,
            meta: { requiresAuth: true },
        },
        {
            path: '/channels/create',
            name: 'cms-channels-create',
            component: ChannelEdit,
            meta: { requiresAuth: true },
        },
        {
            path: '/channels/:channel_id(\\d+)/edit',
            name: 'cms-channels-edit',
            component: ChannelEdit,
            meta: { requiresAuth: true },
        },
        {
            path: '/channels/:channel_id(\\d+)',
            name: 'cms-channels-view',
            component: ChannelView,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            path: '/channels/:channel_id(\\d+)/broadcasts/:broadcast_id(\\d+)',
            name: 'cms-channels-broadcast',
            component: ChannelBroadcast,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            path: '/recording-files',
            name: 'cms-recording-files',
            component: RecordingFiles,
            meta: { requiresAuth: true },
        },
        {
            path: '/statistics/channel',
            name: 'cms-statistics-channel',
            component: StatisticsChannel,
            meta: { requiresAuth: true },
        },
        {
            path: '/statistics/viewer-environment',
            name: 'cms-statistics-viewer-environment',
            component: StatisticsViewerEnvironment,
            meta: { requiresAuth: true },
        },
        {
            path: '/statistics/storage-usage',
            name: 'cms-statistics-storage-usage',
            component: StatisticsStorageUsage,
            meta: { requiresAuth: true },
        },
        {
            path: '/statistics/service-usage',
            name: 'cms-statistics-service-usage',
            component: StatisticsServiceUsage,
            meta: { requiresAuth: true },
        },
        {
            path: '/statistics/service-logs',
            name: 'cms-statistics-service-logs',
            component: StatisticsServiceLogs,
            meta: { requiresAuth: true },
        },
        {
            path: '/chatting-statistics/usage',
            name: 'cms-chatting-statistics-usage',
            component: ChattingStatisticsUsage,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/general',
            name: 'cms-preferences-general',
            component: PreferencesGeneral,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/service_account',
            name: 'cms-preferences-service_account',
            component: PreferencesServiceAccount,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/login_account',
            name: 'cms-preferences-login_account',
            component: PreferencesLoginAccount,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/profile_groups',
            name: 'cms-preferences-profile-groups',
            component: PreferencesProfileGroups,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/profile_groups/:profile_group_id(\\d+)',
            name: 'cms-preferences-profile-groups-view',
            component: PreferencesProfileGroup,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/members',
            name: 'cms-preferences-members',
            component: PreferencesMembers,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/duplicate_block/manage',
            name: 'cms-preferences-duplicate_block_manage',
            component: PreferencesDuplicateBlockManage,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/duplicate_block/sessions',
            name: 'cms-preferences-duplicate_block_sessions',
            component: PreferencesDuplicateBlockSessions,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/duplicate_block/logs',
            name: 'cms-preferences-duplicate_block_logs',
            component: PreferencesDuplicateBlockLogs,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/capture_block/logs',
            name: 'cms-preferences-capture_block_logs',
            component: PreferencesCaptureBlockLogs,
            meta: { requiresAuth: true },
        },
        {
            path: '/preferences/capture_block/block_users',
            name: 'cms-preferences-capture_block_users',
            component: PreferencesCaptureBlockUsers,
            meta: { requiresAuth: true },
        },
        {
            path: '/creator/channel',
            name: 'cms-creator-channel-view',
            component: CreatorChannelView,
            props: true,
            meta: { requiresAuth: true },
        },
        {
            path: '/programs/media_contents',
            name: 'cms-program-media-contents',
            component: ProgramMediaContents,
            meta: { requiresAuth: true },
        },
        {
            path: '/programs/schedules',
            name: 'cms-program-schedules',
            component: ProgramSchedules,
            meta: { requiresAuth: true },
        },
        {
            path: '/programs/wait_media_contents',
            name: 'cms-program-wait-media-contents',
            component: ProgramWaitMediaContents,
            meta: { requiresAuth: true },
        },
        { path: '*', component: PageNotFound },
    ],
    // linkActiveClass: 'active',
});

router.beforeEach((to, from, next) => {
    // initialize channel's list query
    localStorage.setItem('query', '');

    if (to.matched.some(record => record.meta.requiresAuth)) {
    }

    next();
});

export default router;
